export default {
  title: 'Relatório MRR',
  fields: {
    name: 'Nome',
    area: 'Área',
    mrr: 'MRR (líquido)',
  },
  buttons: {
    download_report: 'Descarregar relatório',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados, atualize a página',
  },
};
